import React from "react";

import CssBaseline from "@material-ui/core/CssBaseline";
import Validators from "./Validators";
import Kyr from "./Kyr";
import SvgButton from "./svgbutton";



const Screens = {
  // TIMESTAMPS: "Timestamps",
  VALIDATORS: "Validators",
  KYR_METRICS: "KyrMetrics",
};

const AvailableScreens = [
  // Screens.TIMESTAMPS,
  Screens.VALIDATORS,
  Screens.KYR_METRICS,
];

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      screen: null,
    };
  }
  updateScreen(screen) {
    this.setState({ loading:false, screen: screen });
    console.log("state updated : " + this.state);
  }
  renderOptions() {
   
    return AvailableScreens.map((screen) => (
      <SvgButton
        key = {screen}
        onClick={() => {
          console.log("clicked button!");
          this.updateScreen(screen);
        }}
        variant="contained"
        size="large"
        
      >
        {screen}
      </SvgButton>
    ));
  }
  render() {
    const myStyle = {
      color: "white",
      // backgroundColor: "DodgerBlue",
      padding: "10px",
      fontFamily: "Sans-Serif"
    };
    return (
      <React.Fragment>
        <CssBaseline />
        <header className="dashboard-header" ></header>
        <div style={myStyle}>{this.renderOptions()} 
          <br/>
          <br/>
        </div>
        <div>{this.renderDashboard()}</div>
      </React.Fragment>
    );
    
  }

  renderDashboard() {
    if (this.state.screen) {
      switch (this.state.screen) {
        case Screens.VALIDATORS:
          return <Validators offset={0} limit={200}></Validators>;
        case Screens.KYR_METRICS:
          return <Kyr />;
        default:
          return <div />;
      }
    }
  }
}

export default Dashboard;
